import {
  Avatar,
  DataTableColumn,
  Tag,
  Timestamp,
} from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

import { AppLink } from 'components/appLink';
import { UserBan } from 'hooks/useBans/types';
import { channelAttributes } from 'utils/channels';

import styles from './styles.module.scss';

export const banHistoryColumns: DataTableColumn<UserBan>[] = [
  {
    label: '#',
    selector: function renderCsid({ csid }: UserBan): JSX.Element {
      return (
        <AppLink
          path="/conversation/:csid"
          params={{ path: { csid: `${csid}` } }}
        >
          #{csid}
        </AppLink>
      );
    },
  },
  {
    label: 'Banned by',
    selector: function renderBannedBy({ banning_agent }: UserBan): JSX.Element {
      return (
        <div className={styles.user}>
          <Avatar user={banning_agent} />
          <div className={styles.userName}>{banning_agent.name}</div>
        </div>
      );
    },
  },
  {
    label: 'Channel',
    selector: function renderChannel({ channel }: UserBan): string | undefined {
      return (channel && channelAttributes[channel]?.name) || 'Unknown';
    },
  },
  {
    label: 'Status',
    selector: function renderStatus({ unbanned_at }: UserBan): JSX.Element {
      return (
        <Tag color={unbanned_at ? colors.neutral['500'] : colors.green['500']}>
          {unbanned_at ? 'Inactive' : 'Active'}
        </Tag>
      );
    },
  },
  {
    label: 'Banned on',
    selector: function renderBannedAt({ banned_at }: UserBan): JSX.Element {
      return <Timestamp relative time={banned_at} />;
    },
  },
];

export const banHistorySubColumns: DataTableColumn<UserBan>[] = [
  {
    label: 'Unbanned by',
    selector: function renderUnbannedBy({
      unbanning_agent,
    }: UserBan): JSX.Element | null {
      if (unbanning_agent) {
        return (
          <div className={styles.user}>
            <Avatar user={unbanning_agent} />
            <div className={styles.userName}>{unbanning_agent.name}</div>
          </div>
        );
      }
      return null;
    },
  },
  {
    label: 'Unbanned on',
    selector: function renderUnbannedOn({
      unbanned_at,
    }: UserBan): JSX.Element | null {
      if (unbanned_at) {
        return <Timestamp relative time={unbanned_at} />;
      }
      return null;
    },
  },
];
